import { render } from "./DigitalAgency.vue?vue&type=template&id=05582a96"
import script from "./DigitalAgency.vue?vue&type=script&lang=js"
export * from "./DigitalAgency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__